<template>
  <v-layout row justify-center>
    <v-snackbar top v-model="popup" color="warning" :timeout="timeout">
      {{ popupText }}

      <template v-slot:action="{ attrs }">
        <v-btn plain text v-bind="attrs" @click="popup = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-card min-width="360px" class="mt-16 rounded-xl" :loading="loading">
      <v-card-title class="justify-center">
        <span class="headline">Вход в систему</span>
      </v-card-title>
      <v-card-text class="mb-0 pb-0 mt-2">
        <v-form>
          <v-text-field
            label="E-mail"
            v-model="email"
            :append-icon="emailOk ? 'mdi-check' : ''"
            :error-messages="emailErrors"
            @input="$v.email.$touch()"
            @keydown="cleanError"
            autocomplete
            required
            class="px-4"
          ></v-text-field>
          <v-text-field
            label="Пароль"
            v-model="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            @input="$v.password.$touch()"
            :error-messages="passwordErrors"
            @blur="$v.password.$touch()"
            @click:append="show = !show"
            @keydown="cleanError"
            required
            autocomplete
            :type="show ? 'text' : 'password'"
            class="px-4"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-8 justify-center">
        <v-btn
          color="light-blue lighten-4"
          class="mb-4 rounded text-none subtitle-1"
          block
          tile
          :disabled="this.$v.$invalid"
          :loading="loading"
          :disable="loading"
          @click="submit"
        >
          Войти
        </v-btn>
      </v-card-actions>
      <v-card-actions class="d-flex justify-space-around">
        <router-link to="/register" class="link"> Регистрация </router-link>
        <router-link to="/password-restore" class="link">
          Забыли пароль?
        </router-link>
        <!-- <p></p -->
      </v-card-actions>
    </v-card>
  </v-layout>
</template>


<script>
import auth from "../config/auth";
// import axios from "axios";
import { required, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapActions } from "vuex";

export default {
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      email,
      isUnique(value) {
        if (value === "") return true;
        this.checkingUsername = true;

        return auth
          .post(this.check_url, { email: this.email })
          .then((response) => {
            // console.log(response);
            this.checkingUsername = false;
            this.emailOk = true;
            return !response.data.result;
          })
          .catch(() => {
            this.emailOk = false;
            return false;
          });
      },
    },
    password: {
      required,
      error() {
        return !this.formErrors;
      },
      // minLength: minLength(8),
      // containsUppercase: function (value) {
      //   return /[A-Z]/.test(value);
      // },
      // containsLowercase: function (value) {
      //   return /[a-z]/.test(value);
      // },
      // containsNumber: function (value) {
      //   return /[0-9]/.test(value);
      // },
    },
  },

  data: () => ({
    email: "",
    password: "",
    check_url: "/auth/check_email_unique/",
    url: "/auth/jwt/create/",
    checkbox: false,
    submitStatus: "",
    formErrors: "",
    show: false,
    emailOk: false,
    loader: null,
    loading: false,
    timeout: 3000,
    popup: false,
    popupText: "",
  }),

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      const email_regex = !this.$v.email.email;
      const email_required = !this.$v.email.required;
      email_regex && errors.push("Введёный адрес не является e-mail");
      email_required && errors.push("E-mail - обязательное поле");
      if (!email_regex && !email_required) {
        !this.$v.email.isUnique &&
          errors.push("Такой E-mail не зарегистрирован");
      }
      // console.log("errors: " + errors);
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      this.formErrors && errors.push("Введенны неверные логин/пароль");
      // console.log(errors);
      return errors;
    },
  },

  methods: {
    ...mapActions(["setEmail", "login"]),
    cleanError: function () {
      this.formErrors = "";
      this.emailOk = false;
    },
    async submit() {
      this.$v.$touch();

      this.loading = true;
      // console.log("email:" + this.email);

      let email = this.email;
      let password = this.password;
      try {
        await this.login({ email, password });
      } catch (e) {
        var msg = e.message;
        if (msg.includes("401")) {
          console.log(JSON.stringify(e.message));
          this.popupText = "Введена неверная пара логин / пароль";
          this.popup = true;
          this.loading = false;
        }
        return;
      }
      // this.$router.push({ name: "mk" });
      // console.log("IN then...");
      this.loading = false;
      // console.log(localStorage.getItem("token"));
      this.$router.push({ name: "home" });
      // this.setEmail({ email: this.email });
      // })
      // .catch((err) => {
      //   this.loading = false;
      //   console.log("catched error");
      //   console.log("Status from Vuex: " + this.$store.getters.getError);
      //   this.formErrors = this.$store.getters.getError;
      //   console.log(err);
      // });
    },
    checkEmail() {
      // console.log("Check url:");
      // console.log(this.check_url);
      auth.post(this.check_url, { email: this.email }).then((response) => {
        return response;
      });
    },
    emailNotOk() {
      this.emailOk = false;
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var token = localStorage.getItem("token");
      if (token) {
        vm.$router.push({ name: "home" });
      }
    });
  },
};
</script>

<style scoped>
.link {
  color: #777;
  margin-bottom: 5px;
}
input:-internal-autofill-selected {
  background-color: #fff;
}
</style>